import {useFormikContext} from 'formik'
import {FC} from 'react'

import {IncludedPriceBenefits} from '@/components/common/benefits/IncludedPriceBenefits'
import {FormSection} from '@/components/common/form/FormSection'
import {useTrademarkVerificationContent} from '@/content/trademarkVerification'
import {useTranslation} from '@/i18n'

import {Summary} from '../summary/Summary'
import {TrademarkVerificationFields} from '../types'
import {MarketsSelectionWithModal} from './modal/MarketsSelectionWithModal'

type MarketsInfoProps = {
  ssrMobileDetected: boolean
}

export const MarketsInfo: FC<MarketsInfoProps> = ({ssrMobileDetected}) => {
  const {t} = useTranslation()
  const {title, feesDescription} = useTrademarkVerificationContent().markets
  const {values} = useFormikContext<TrademarkVerificationFields>()

  const selectedMarkets = values.jurisdictions

  return (
    <FormSection
      title={t(title)}
      description={<IncludedPriceBenefits description={feesDescription} />}
    >
      <MarketsSelectionWithModal
        selectedMarkets={selectedMarkets}
        numOfVisibleMarkets={ssrMobileDetected ? 4 : 6}
        summary={<Summary />}
      />
    </FormSection>
  )
}
